import type { Row, Table } from '@tanstack/react-table';

export const MOBILE_TABLE_UTILITY_COLUMN_ID = {
  SELECT: 'select',
  ACTION: 'action',
  ACTIONS: 'actions',
} as const;

export const MOBILE_TABLE_META_COLUMN_ID = {
  ROW_NUMBER: 'rownumber',
} as const;

export const MOBILE_TABLE_RECORD_ID_COLUMN_ID = {
  ID: 'id',
  INVOICE_ID: 'invoiceid',
  RECORD_ID: 'recordid',
} as const;

export type MobileTableUtilityColumnId =
  (typeof MOBILE_TABLE_UTILITY_COLUMN_ID)[keyof typeof MOBILE_TABLE_UTILITY_COLUMN_ID];

export interface MobileTableCardProps<TData> {
  row: Row<TData>;
}

export interface MobileTableCardListProps<TData> {
  table: Table<TData>;
  isUpdating?: boolean;
}
